import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Strings from "../../utils/stringUtil";
import TextSize from "../../utils/textSizeUtil";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";
import styles from "../../assets/styles/main.module.css";
import theme from "../../utils/themeUtil";
import { Link } from "react-router-dom";
import Routes from "../../utils/routesUtil";

function AccessBenefitsDownloadApp() {
    return (
        <React.Fragment>
            <Box bgcolor={theme.palette.lightWhite.main} py={isMobile ? 2 : 7}>
                <Box className={styles.container}>
                    <Box
                        bgcolor={theme.palette.white.main}
                        px={isMobile ? 2 : 12}
                        pt={isMobile ? 2 : 8}
                        style={{ borderRadius: "24px" }}
                    >
                        <Grid container spacing={2} alignItems="center">
                            <Grid
                                item
                                xs={12}
                                md={8}
                                style={{ textAlign: isMobile ? "center" : "left" }}
                            >
                                <Box>
                                    <Typography
                                        style={{
                                            fontSize: isMobile ? TextSize.size24 : TextSize.size32,
                                            color: theme.palette.black.main,
                                            fontWeight: "600",
                                        }}
                                    >
                                        {Strings.downloadMMApp}
                                    </Typography>

                                    <Box>
                                        <Typography
                                            variant="span"
                                            style={{
                                                fontSize: TextSize.size14,
                                                color: theme.palette.black.main,
                                                fontWeight: "600",
                                            }}
                                        >
                                            {Strings.thousandsOfWomen}
                                        </Typography>
                                        <Typography
                                            variant="span"
                                            style={{
                                                fontSize: TextSize.size14,
                                                color: theme.palette.black.main,
                                            }}
                                        >
                                            {Strings.thousandsOfWomenDesc}
                                        </Typography>
                                    </Box>

                                    <Box mt={3}>
                                        <Link
                                            to={Routes.MM_PLAY_STORE_URL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                src={AppIcons.imgDownloadApp}
                                                alt={Strings.mahilaMoney}
                                                style={{
                                                    width: isMobile ? "150px" : "200px",
                                                    height: "auto",
                                                }}
                                            />
                                        </Link>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={3}
                                style={{ textAlign: isMobile ? "center" : "left" }}
                            >
                                <img
                                    src={AppIcons.imgAppMobile}
                                    alt="Loan"
                                    height={isMobile ? "250" : "400"}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        </React.Fragment>
    );
}

export default AccessBenefitsDownloadApp;
